import api from "./index";
import type { ChatMessage, ChatResponse } from "./types";

export const chatApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getChat: builder.query<ChatResponse, void>({
      query: () => ({ url: "/chat", params: { limit: 150 } }),
      providesTags: ["Chat"],
    }),
    sendMessage: builder.mutation<{ message: ChatMessage }, { text: string; clientId: string }>({
      query: (body) => ({ url: "/chat", method: "POST", body }),
      // Show the message straight away; the poll replaces it with the saved copy.
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        const patch = dispatch(chatApi.util.updateQueryData("getChat", undefined, (draft) => {
          draft.messages.push({ id: -Date.now(), kind: "in", text: arg.text, from: "me", agentName: null, at: new Date().toISOString(), clientId: arg.clientId, seen: false, pending: true });
          draft.status = "active";
        }));
        try {
          const { data } = await queryFulfilled;
          dispatch(chatApi.util.updateQueryData("getChat", undefined, (draft) => {
            const i = draft.messages.findIndex((m) => m.clientId === arg.clientId);
            if (i >= 0) draft.messages[i] = data.message; else draft.messages.push(data.message);
          }));
        } catch {
          patch.undo();
          dispatch(chatApi.util.updateQueryData("getChat", undefined, (draft) => {
            draft.messages.push({ id: -Date.now(), kind: "in", text: arg.text, from: "me", agentName: null, at: new Date().toISOString(), clientId: arg.clientId, seen: false, failed: true });
          }));
        }
      },
    }),
    markRead: builder.mutation<{ ok: boolean }, { upTo: number }>({
      query: (body) => ({ url: "/chat/read", method: "POST", body }),
    }),
  }),
});

export const { useGetChatQuery, useSendMessageMutation, useMarkReadMutation } = chatApi;
